import {
    Button,
    Col,
    Form,
    Modal,
    Input,
    Row,
    Table,
    Select,
    message,
    Radio,
    Space,
    DatePicker,
    Tooltip,
} from 'antd'
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import qs from 'qs'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { Dialog } from 'primereact/dialog'
import moment from 'moment'
import TimeUtils from '../../utils/TimeUtils'
import {
    getPosts,
    createPost,
    updatePost,
    deletePost,
    batchUpdatePostsStatus,
} from '../../_services/service'
import { SearchForm } from './search-form'
import { PostForm } from './post-form'
import RosterForm from '../etimeform/RosterForm'
import { BatchUpdatePostsStatusForm } from './batch-update-posts-status-form'
import { viewConstants } from '../../_constants/view.constants'
import { rosterService } from '../../_services'

moment.locale('en-nz')

const getRandomuserParams = params => ({
    results: params.pagination?.pageSize,
    page: params.pagination?.current,
    ...params,
})
function antdPaginationAdapter(apiPagination, onShowSizeChange) {
    return {
        current: apiPagination.page,
        total: apiPagination.total,
        pageSize: apiPagination.pageSize,
        showSizeChanger: true,
        showTotal: () => {
            return `total ${apiPagination.total}`
        },
    }
}

function overlapTest(record, data) {
    const range1 = moment.range(
        record.PayrollEmpRosterStartDate,
        record.PayrollEmpRosterEndDate
    )

    for (const d of data) {
        let range2 = moment.range(
            d.PayrollEmpRosterStartDate,
            d.PayrollEmpRosterEndDate
        )
        if (
            d.PayrollEmpRosterAutoID !== record.PayrollEmpRosterAutoID &&
            d.PayrollEmpRosterEmployeeID == record.PayrollEmpRosterEmployeeID &&
            range1.overlaps(range2)
        ) {
            return 'rostertable-highlight'
        }
    }
    if (record.PayrollEmpRosterStatus) {
        return 'rostertable-disabled'
    }

    return ''
}

function validIntOrUndefined(value) {
    const num = Number.parseInt(value, 10)
    return !Number.isNaN(num) ? num : undefined
}
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max)
}
function handleDelete(record, onSuccess) {
    Modal.confirm({
        title: 'Delete Roster',
        content: (
            <p>Are you sure to delete {record.PayrollEmpRosterDispTitle} ?</p>
        ),
        onOk: async () => {
            try {
                await rosterService.removeEventById(record.id)

                message.success('Sucessfully deleted')
                onSuccess()
            } catch (e) {
                message.error('Delete unsuccessful')
            }
        },
    })
}
/**
 * 
 * @param {*} records 
 * @param {*} onSuccess 
 * @param {*} onCancel 
 */
function handleBulkDelete(records, onSuccess, onCancel) {
    Modal.confirm({
        title: 'Delete Rosters',
        content: <p>Are you sure to delete {records.length} rosters?</p>,
        onOk: async () => {
            try {

                const ids = _.map(records, record => record.id)
                await rosterService.removeRosters(ids)

                message.success('Sucessfully deleted')
                onSuccess()
                onCancel()
            } catch (e) {
                message.error('Delete unsuccessful')
            }
        },
        onCancel: () => onCancel(),
    })
}

/**
 * 
 * @param {*} records 
 * @param {*} onSuccess 
 * @param {*} onCancel 
 */
function undoApproval(records, onSuccess, onCancel) {
    Modal.confirm({
        title: 'Undo Approval',
        content: <p>Are you sure to disapprove {records.length} rosters?</p>,
        onOk: async () => {
            try {

                const recordIds = _.map(
                    records,
                    r => r.PayrollEmpRosterAutoID
                )
                await rosterService.undoApproval({
                    rosters: recordIds,
                })

                message.success('Undo approval success')
                onSuccess()
                onCancel()
            } catch (e) {
                message.error('Undo Approval unsuccessful')
            }
        },
        onCancel: () => onCancel(),
    })
}

function submitForApproval(records, onSuccess, onCancel) {
    Modal.confirm({
        title: 'Approve Rosters',
        content: <p>Are you sure to approve {records.length} rosters?</p>,
        onOk: async () => {
            try {
                const invalidRecord = _.find(
                    records,
                    record => record.overlap === true
                )
                if (invalidRecord != undefined) {
                    message.error(
                        'Approvement rejected. Time conflict in roster records. '
                    )
                    onCancel()
                } else {
                    const recordIds = _.map(
                        records,
                        r => r.PayrollEmpRosterAutoID
                    )
                    const result = await rosterService.submit({
                        rosters: recordIds,
                    })
                    message.success('Sucessfully approved')
                    onSuccess()
                    onCancel()
                }
            } catch (e) {
                message.error(e.message)
            }
        },
        onCancel: () => onCancel(),
    })
}

/**
 * 
 * @param {*} records 
 * @param {*} onSuccess 
 * @param {*} onCancel 
 */
function sendNotification(records, onSuccess, onCancel) {

    Modal.confirm({
        title: 'Send Notification',
        content: (
            <p>Are you sure to send sms to the selected rosters?</p>
        ),
        onOk: async () => {
            try {
                // await rosterService.removeEventById(record.id)

                message.success('Sucessfully sent')
                onSuccess()
            } catch (e) {
                message.error('Failed to send notification')
            }
        },
    })
}

export default function App() {
    const dispatch = useDispatch()

    const [form] = Form.useForm()

    const [isEditing, setIsEditing] = useState(false)
    const [editingStudent, setEditingStudent] = useState(null)
    // const [data, setData] = useState()
    // const [loading, setLoading] = useState(false)
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    })

    // function getDefaultQuery() {
    //     // 先不考虑服务端渲染
    //     const urlSearchParams = qs.parse(window.location.search, {
    //         ignoreQueryPrefix: true,
    //     })
    //     const { page, pageSize, title, status, order } = urlSearchParams
    //     const dto = {}
    //     if (typeof page === 'string') {
    //         dto.page = validIntOrUndefined(page) || 1
    //     }
    //     if (typeof pageSize === 'string') {
    //         dto.pageSize = validIntOrUndefined(pageSize) || 20
    //     }
    //     if (typeof title === 'string') {
    //         dto.title = title
    //     }
    //     if (typeof status === 'string') {
    //         dto.status = validIntOrUndefined(status)
    //     }
    //     if (typeof order === 'string') {
    //         const orderNum = validIntOrUndefined(order)
    //         dto.order = orderNum ? clamp(orderNum, 0, 1) : undefined
    //     }
    //     return dto
    // }

    function getDefaultQuery(query) {
        const dto = {}
        dto.range = query.range || 'week'
        dto.time = query.time || moment()
        // dto.start = query.start || moment().startOf('week')
        dto.end = query.end || moment().endOf('week')
        dto.status = query.status || 0
        dto.employees = query.employees || []
        dto.note = query.note || ''
        dto.page = query.page || 1
        dto.pageSize = query.pageSize || 20
        dto.presubmitValidation = true
        return dto
    }

    const [defaultQuery] = useState(getDefaultQuery({}))

    const [query, setQuery] = useState(defaultQuery)

    const [btnStatus, setBtnStatus] = useState(true)

    const [data, setData] = useState({
        list: [],
        pagination: {
            page: 1,
            pageSize: 20,
            total: 0,
        },
    })

    const [loading, setLoading] = useState(false)

    const [selectedRows, setSelectedRows] = useState([])

    const [selectedRecord, setSelectedRecord] = useState()

    const [modalActionType, setModalActionType] = useState('')
    const [modalActionLoading, setModalActionLoading] = useState(false)

    useEffect(() => {
        let isCurrent = true
        setLoading(true)

        const queryObj = Object.assign({}, defaultQuery, query)

        rosterService
            .queryRoster(queryObj)
            .then(res => {
                if (isCurrent) {
                    let obj = {}
                    obj.list = transformDiplayRoster(res)
                    obj.pagination = {
                        total: res.length,
                        page: query.page,
                        pageSize: query.pageSize,
                    }
                    setData(obj)
                }
            })
            .finally(() => isCurrent && setLoading(false))

        // getPosts(query)
        //     .then(res => isCurrent && setData(res))
        //     .finally(() => isCurrent && setLoading(false))

        return () => {
            isCurrent = false
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    const transformDiplayRoster = data => {
        // _.map(data, roster => {
        //     const start = roster.PayrollEmpRosterStartDate
        //     const end = roster.PayrollEmpRosterEndDate
        //     const status = roster.PayrollEmpRosterStatus

        //     moment(start)

        // })
        return data
    }

    const clean = () => {
        setSelectedRecord(undefined)
        setSelectedRows([])
        setBtnStatus(true)
    }
    const handleModalCancel = () => {
        setModalActionType('')
        clean()
    }
    const modalActionFactory = options => {
        const {
            api,
            successMessage = 'success',
            errorMessage = 'unsuccess',
        } = options
        return async (...args) => {
            setModalActionLoading(true)
            try {
                await api(...args)
                message.success(successMessage)
                // 刷新列表
                setQuery(prev => Object.assign({}, prev))
                setBtnStatus(true)
                handleModalCancel()
            } catch (e) {
                message.error(errorMessage)
            } finally {
                setModalActionLoading(false)
            }
        }
    }

    const refreshTable = options => {
        setQuery(prev => Object.assign({}, prev))
        setBtnStatus(true)
    }

    const columns = [
        { dataIndex: 'id', title: 'id' },
        { dataIndex: 'EmployeeName', title: 'employee' },
        {
            dataIndex: 'PayrollEmpRosterStartDate',
            title: 'start',
            render: (_, record) => (
                <span>
                    {moment(record.PayrollEmpRosterStartDate).format(
                        'YYYY-MM-DD hA'
                    )}
                </span>
            ),
        },
        {
            dataIndex: 'PayrollEmpRosterEndDate',
            title: 'end',
            render: (_, record) => (
                <span>
                    {moment(record.PayrollEmpRosterEndDate).format(
                        'YYYY-MM-DD hA'
                    )}
                </span>
            ),
        },
        { dataIndex: 'PayrollEmpRosterActionNotes', title: 'Note' },
        // { dataIndex: 'PayrollEmpRosterDispTitle', title: 'title' },
        { dataIndex: 'PayrollEmpRosterBreakMinute', title: 'break' },
        {
            dataIndex: 'PayrollEmpRosterStatus',
            title: 'status',
            // filters: [
            //     { text: 'Rostered', value: 0 },
            //     { text: 'Approved', value: 1 },
            // ],
            // filterMultiple: true,
            // filteredValue:
            //     query.status === undefined ? undefined : [query.status],
            // onFilter: (value, record) =>
            //     record.PayrollEmpRosterStatus === value,
            render: (_, record) =>
                record.PayrollEmpRosterStatus ? (
                    <span style={{ 
                        color: '#52c41a', 
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}>
                        <span style={{ fontSize: '16px' }}>✓</span>
                        <span>Approved</span>
                    </span>
                ) : (
                    <span style={{ 
                        color: '#1890ff',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}>
                        <span style={{ fontSize: '14px' }}>📋</span>
                        <span>Rostered</span>
                    </span>
                ),
        },
        // {
        //     dataIndex: 'order',
        //     title: 'order',
        //     sorter: true,
        //     sortOrder:
        //         query.order === undefined
        //             ? undefined
        //             : { 0: 'ascend', 1: 'descend' }[query.order],
        // },
        // { dataIndex: 'createdAt', title: 'createdAt', sorter: true },
        // { dataIndex: 'updatedAt', title: 'updatedAt' },
        {
            title: 'Actions',
            render: (_, record) =>
                record.PayrollEmpRosterStatus == false ? (
                    <Space>
                        <span
                            style={{ cursor: 'pointer' }}
                            className="text-primary"
                            onClick={() => {
                                setSelectedRecord(record)
                                setModalActionType('update')
                            }}
                        >
                            Edit
                        </span>
                        <span
                            style={{ color: 'red', cursor: 'pointer' }}
                            className="text-danger"
                            onClick={() =>
                                handleDelete(record, () => {
                                    setBtnStatus(true)
                                    setQuery(prev => {
                                        const prevPage = prev.page || 1
                                        return Object.assign(
                                            Object.assign({}, prev),
                                            {
                                                page:
                                                    data.list.length === 1
                                                        ? clamp(
                                                              prevPage - 1,
                                                              1,
                                                              prevPage
                                                          )
                                                        : prevPage,
                                            }
                                        )
                                    })
                                })
                            }
                        >
                            Delete
                        </span>
                        <span
                            style={{ cursor: 'pointer' }}
                            className="text-warning"
                            onClick={() =>
                                sendNotification(record, () => {
                                    setBtnStatus(true)
                                    setQuery(prev => {
                                        const prevPage = prev.page || 1
                                        return Object.assign(
                                            Object.assign({}, prev),
                                            {
                                                page:
                                                    data.list.length === 1
                                                        ? clamp(
                                                              prevPage - 1,
                                                              1,
                                                              prevPage
                                                          )
                                                        : prevPage,
                                            }
                                        )
                                    })
                                })
                            }
                        >
                            Notification
                        </span>
                    </Space>
                ) : (
                    <span></span>
                ),
        },
    ]

    // const onAddStudent = () => {
    //     const randomNumber = parseInt(Math.random() * 1000)
    //     const newStudent = {
    //         id: randomNumber,
    //         name: 'Name ' + randomNumber,
    //         email: randomNumber + '@gmail.com',
    //         address: 'Address ' + randomNumber,
    //     }
    //     setData(pre => {
    //         return [...pre, newStudent]
    //     })
    // }
    // const onDeleteStudent = record => {
    //     Modal.confirm({
    //         title: 'Are you sure, you want to delete this student record?',
    //         okText: 'Yes',
    //         okType: 'danger',
    //         onOk: () => {
    //             setData(pre => {
    //                 return pre.filter(student => student.id !== record.id)
    //             })
    //         },
    //     })
    // }
    // const onEditStudent = record => {
    //     setIsEditing(true)
    //     setEditingStudent({ ...record })
    // }
    // const resetEditing = () => {
    //     setIsEditing(false)
    //     setEditingStudent(null)
    // }

    // const onFinish = values => {
    //     message.success('Submit success!')
    // }

    // const onFinishFailed = () => {
    //     message.error('Submit failed!')
    // }

    // const onFill = () => {
    //     form.setFieldsValue({
    //         url: 'https://taobao.com/',
    //     })
    // }

    // const periodEndingChange = value => {
    //     console.log(`selected ${value}`)
    // }

    // const onPeriodDateChange = (date, dateString) => {
    //     console.log(date, dateString)
    // }

    // const onShowSizeChange = (current, pageSize) => {
    //     console.log(current, pageSize)
    // }

    const renderEventModel = event => {
        let roster = {}

        roster.id = event.PayrollEmpRosterAutoID
        roster.title = event.PayrollEmpRosterDispTitle
        roster.dateFrom = event.PayrollEmpRosterStartDate
        // roster.dateTo = event.PayrollEmpRosterEndDate
        roster.startTime = TimeUtils.extractTime(
            event.PayrollEmpRosterStartDate
        )
        roster.endTime = TimeUtils.extractTime(event.PayrollEmpRosterEndDate)
        roster.break = event.PayrollEmpRosterBreakMinute || 0
        roster.Note = event.PayrollEmpRosterActionNotes || ''
        roster.status = event.PayrollEmpRosterStatus
        roster.employeeID = event.PayrollEmpRosterEmployeeID

        return roster
    }

    // const handleDelete = (record, onSuccess) => {
    //     Modal.confirm({
    //         title: 'Delete Roster',
    //         content: (
    //             <p>Are you sure to delete {record.PayrollEmpRosterDispTitle} ?</p>
    //         ),
    //         onOk: async () => {
    //             try {
    //                 // await deletePost(record.id)

    //                 await this.props.actions.removeEventById(record.id)

    //                 message.success('Sucessfully deleted')
    //                 onSuccess()
    //             } catch (e) {
    //                 message.error('Delete unsuccessful')
    //             }
    //         },
    //     })
    // }

    return (
        <div>
                <SearchForm
                    defaultQuery={defaultQuery}
                    onSubmit={values => {
                        setBtnStatus(true)
                        setQuery(prev =>
                            Object.assign(
                                Object.assign(Object.assign({}, prev), values),
                                { page: 1 }
                            )
                        )
                        setSelectedRecord()
                        setSelectedRows([])
                    }}
                    onReset={values => {
                        setBtnStatus(true)
                        setQuery(prev =>
                            Object.assign(
                                Object.assign(Object.assign({}, prev), values),
                                { page: 1 }
                            )
                        )
                        setSelectedRecord()
                        setSelectedRows([])
                    }}
                />
                <div style={{ margin: '15px 0' }}>
                    <Space>
                        <Button
                            type="primary"
                            disabled={
                                btnStatus ||
                                selectedRows.length <= 0 ||
                                _.isEmpty(
                                    _.find(
                                        selectedRows,
                                        record =>
                                            record.PayrollEmpRosterStatus === false
                                    )
                                )
                            }
                            onClick={() =>
                                submitForApproval(
                                    selectedRows,
                                    () =>
                                        setQuery(prev => {
                                            const prevPage = prev.page || 1
                                            return Object.assign(
                                                Object.assign({}, prev),
                                                {
                                                    page:
                                                        data.list.length === 1
                                                            ? clamp(
                                                                  prevPage - 1,
                                                                  1,
                                                                  prevPage
                                                              )
                                                            : prevPage,
                                                }
                                            )
                                        }),
                                    clean
                                )
                            }
                            // onClick={() => {
                            //     setModalActionType('batchUpdateStatus')
                            // }}
                        >
                            Manager Approval
                        </Button>
                        <Button
                            type="primary"
                            danger
                            disabled={
                                btnStatus ||
                                selectedRows.length <= 0 ||
                                _.isEmpty(
                                    _.find(
                                        selectedRows,
                                        record =>
                                            record.PayrollEmpRosterStatus === true
                                    )
                                )
                            }
                            onClick={() =>
                                undoApproval(
                                    selectedRows,
                                    () =>
                                        setQuery(prev => {
                                            const prevPage = prev.page || 1
                                            return Object.assign(
                                                Object.assign({}, prev),
                                                {
                                                    page:
                                                        data.list.length === 1
                                                            ? clamp(
                                                                  prevPage - 1,
                                                                  1,
                                                                  prevPage
                                                              )
                                                            : prevPage,
                                                }
                                            )
                                        }),
                                    clean
                                )
                            }
                        >
                            Undo Approval
                        </Button>
                        <Button
                            type="primary"
                            danger
                            disabled={
                                btnStatus ||
                                selectedRows.length <= 0 ||
                                _.isEmpty(
                                    _.find(
                                        selectedRows,
                                        record =>
                                            record.PayrollEmpRosterStatus === false
                                    )
                                )
                            }
                            onClick={() =>
                                handleBulkDelete(
                                    selectedRows,
                                    () =>
                                        setQuery(prev => {
                                            const prevPage = prev.page || 1
                                            return Object.assign(
                                                Object.assign({}, prev),
                                                {
                                                    page:
                                                        data.list.length === 1
                                                            ? clamp(
                                                                  prevPage - 1,
                                                                  1,
                                                                  prevPage
                                                              )
                                                            : prevPage,
                                                }
                                            )
                                        }),
                                    clean
                                )
                            }
                        >
                            Delete
                        </Button>
                        <Button
                            type="primary"
                            disabled={
                                btnStatus ||
                                selectedRows.length <= 0 ||
                                _.isEmpty(
                                    _.find(
                                        selectedRows,
                                        record =>
                                            record.PayrollEmpRosterStatus === false
                                    )
                                )
                            }
                            onClick={() =>
                                sendNotification(
                                    selectedRows,
                                    () =>
                                        setQuery(prev => {
                                            const prevPage = prev.page || 1
                                            return Object.assign(
                                                Object.assign({}, prev),
                                                {
                                                    page:
                                                        data.list.length === 1
                                                            ? clamp(
                                                                  prevPage - 1,
                                                                  1,
                                                                  prevPage
                                                              )
                                                            : prevPage,
                                                }
                                            )
                                        }),
                                    clean
                                )
                            }
                        >
                            Send Notification
                        </Button>
                    </Space>
                </div>
                <Table
                    rowKey="id"
                    dataSource={data.list}
                    columns={columns}
                    loading={loading}
                    pagination={Object.assign(
                        {},
                        antdPaginationAdapter(data.pagination)
                    )}
                    // rowClassName={record => {
                    //     if (record.PayrollEmpRosterStatus != 0) {
                    //         return 'rostertable-disabled'
                    //     } else {
                    //         return 'rostertable-highlight'
                    //     }
                    // }}
                    // rowClassName={record => overlapTest(record, data.list)}
                    rowClassName={record => {
                        if (record.PayrollEmpRosterStatus) {
                            return 'rostertable-disabled'
                        } else if (record.overlap) {
                            return 'rostertable-highlight'
                        }
                    }}
                    onChange={(pagination, filters, sorter) => {
                        setQuery(prev =>
                            Object.assign(Object.assign({}, prev), {
                                page: pagination.current || 1,
                                pageSize: pagination.pageSize || 20,
                                status:
                                    filters.status && filters.status.length > 0
                                        ? Number(filters.status[0])
                                        : undefined,
                                order:
                                    !Array.isArray(sorter) &&
                                    !!sorter.order &&
                                    sorter.field === 'order'
                                        ? { ascend: 0, descend: 1 }[
                                              sorter.order
                                          ]
                                        : undefined,
                            })
                        )
                    }}
                    rowSelection={{
                        selectedRowKeys: selectedRows.map(item => item.id),
                        renderCell(checked, record, index, node) {
                            if (record.PayrollEmpRosterStatus) {
                                return (
                                    <Tooltip title="Approved">{node}</Tooltip>
                                )
                            }
                            return node
                        },
                        // getCheckboxProps: record => {
                        //     let checkboxProps = {}
                        //     if (record.PayrollEmpRosterStatus !== 0) {
                        //         checkboxProps.disabled = true
                        //     }
                        //     return checkboxProps
                        // },
                        onChange: (_, rows) => {
                            setSelectedRows(rows)
                            setBtnStatus(false)
                        },
                    }}
                ></Table>
                <Dialog
                    header="Update Post"
                    visible={modalActionType === 'update'}
                    // footer={renderFooter('displayBasic')}
                    onHide={handleModalCancel}
                    maximized={false}
                    maximizable={true}
                    resizable={true}
                    breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                    style={{ width: '50vw' }}
                >
                    <RosterForm
                        event={
                            selectedRecord
                                ? renderEventModel(selectedRecord)
                                : {}
                        }
                        showEmployee={true}
                        disableEmployeeSelection={true}
                        onHide={handleModalCancel}
                        onSubmitRefresh={refreshTable}
                    />
                </Dialog>
                <BatchUpdatePostsStatusForm
                    visible={modalActionType === 'batchUpdateStatus'}
                    records={selectedRows}
                    loading={modalActionLoading}
                    onCancel={handleModalCancel}
                    onSubmit={modalActionFactory({
                        api: batchUpdatePostsStatus,
                        successMessage: 'Bulk Edit finished',
                        errorMessage: 'Bulk Edit unsuccessful',
                    })}
                />

        </div>
    )
}
